import {FC, ReactNode} from 'react';
import clsx from 'clsx';

export type StackedProps = {
    children: ReactNode;
    className?: string;
};

const Stacked: FC<StackedProps> = ({children, className}) => (
    <div className={clsx('stacked', className)}>{children}</div>
);

export default Stacked;
